<template>
    <div class="right-part mail-details bg-white">
        <div class="card-body bg-light">
            <button type="button" id="back_to_inbox" class="btn btn-outline-secondary font-18 m-r-10" @click="goBack()"><i class="mdi mdi-arrow-left"></i></button>
            <div class="btn-group m-r-10" role="group" aria-label="Button group with nested dropdown">
                <!-- <button type="button" class="btn btn-outline-secondary font-18"><i class="mdi mdi-reply"></i></button> -->
                <button type="button" class="btn btn-outline-secondary font-18" @click="deleteMail()"><i class="mdi mdi-delete"></i></button>
            </div>
        </div>
        <div class="card-body border-bottom">
            <h4 class="m-b-0">{{mail.subject}}</h4>
        </div>
        <div class="card-body border-bottom">
            <div class="d-flex no-block align-items-center m-b-40">
                <div class="m-r-10">
                    <blockie  v-if="mail.sender_email" :address="mail.sender_email" :width="45"></blockie>
                </div>
                <div class="">
                    <h5 class="m-b-0 font-16 font-medium">{{mail.sender_first_name}} {{mail.sender_last_name}}
                    </h5>
                    <span>to <span v-for="(r, index) in mail.recipients" v-bind:key="index">{{r.first_name}} {{r.last_name}}; &nbsp;</span></span>
                </div>
            </div>
            <p>{{mail.message}}</p>
        </div>
        <div class="card-body" v-if="mail.attachments?mail.attachments.length > 0: []">
            <h4><i class="fa fa-paperclip m-r-10 m-b-10"></i> Attachments <span>({{mail.attachments.length}})</span></h4>
            <div class="row">
                <div class="attachments">
                    <div v-for="(attachment, idx) in mail.attachments"><span href="#" v-on:click="getDownloadUrl(idx)">{{ attachment.filename }}</span></div>
                </div>
            </div>
            <div class="border m-t-20 p-15">
                <p class="p-b-20">click here to <a href="javascript:void(0)">Reply</a> or <a href="javascript:void(0)">Forward</a></p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../common/Blockie";


    export default {
        name: "Mail",
        props: ["mailid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie},
        data() {
            return {
                mail: {
                    attachments: []
                }
            };
        },
        mounted() {
            this.getMail();
        },
        methods: {
            getMail() {
                this.$http
                .get("/mailbox/" + this.mailid)
                .then(reply => {
                    this.mail = reply.data;
                })
                .catch(err => {
                    console.error(err);
                })
            },
            async getDownloadUrl(index) {
                let filepath = this.mail.attachments[index].filepath;
                this.$http.get(`/mailbox/${this.mailid}/signedUrl?type=read&key=${filepath}`)
                .then(result => {
                    window.location.href = result.data.url;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            async deleteMail() {
                await this.$http.delete(`/mailbox/${this.mailid}`);
                await this.goBack();
            },
            goBack() {
                window.history.back();
            }
        }
    }
</script>

<style scoped>
    .attachments > div {
        margin: 15px 0 0 15px;
        padding: 5px 15px;
        border: #0c5460 solid 2px;
        border-radius: 50px;
        color: #3e5569;
        display: inline;
    }

    .attachments > div > span {
        margin-left: 7pX;
        cursor: pointer;
    }
</style>
